<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por uma empresa" v-model="searchText"
                      style="max-width: 400px"
        :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.buildFilter());
    },
    onSelectItem() {
      this.onChangeFilter(this.buildFilter());
    },
    buildFilter() {
      let filter = '';
      if (this.searchText) {
        if (filter) {
          filter += ' and ';
        }
        filter += `fornecedor like '%${this.searchText.toLowerCase()}%' or key = '${this.searchText}'`;
      }
      return filter;
    },
  },
  data() {
    return {
      searchText: null,
    };
  },
};
</script>
